import { PowerBiReport, ViewModel, EmbedTokenResult, ActivityLogEntry, User, ExportFileRequest } from '../models/models';
import { isExpired, decodeToken } from "react-jwt";

export default class AppOwnsDataWebApi {
  //Note: The web api port needs to set to :44302 for development and to an empty string for production
  private static baseUrl = window.location.protocol + "//" + window.location.hostname + "";
  public static ApiRoot: string = this.baseUrl + "/api/";
  public static SamlRoot: string = this.baseUrl + "/saml/";

  public static GetAccessToken(): string {
    const accessToken = sessionStorage.getItem("accessToken");
    if (accessToken === "") return "";

    const expired = isExpired(accessToken);
    if (expired) {
      console.log("In GetAccessToken, accessToken has expired");
      sessionStorage.setItem("isAuthenticated", "false");
      sessionStorage.setItem("accessToken", "");
      sessionStorage.setItem("LoginId", "");
      sessionStorage.setItem("UserName", "");

      return "";
    }

    return accessToken;
  }

  static GetAuthorization = async (): Promise<string> => {
    var restUrl = this.ApiRoot + "authorization";

    const response = await fetch(restUrl, {
      method: "GET",
      credentials: 'include',
      headers: {
        "Accept": "application/text;"
      }
    });

    //console.log("In GetAuthorization, Response = " + response.status);

    if(response.ok) {
      const stringResponse = await response.text();
      //console.log("In GetAuthorization, stringResponse = " + stringResponse);
      return stringResponse;
    } else {
      return null;
    }
  }

  static GetRenewedJWT = async (): Promise<string> => {
    const accessToken = this.GetAccessToken();
    if (accessToken === "") return null;
    //console.log("In GetRenewedJWT, accessToken = " + accessToken);
   
    var restUrl = this.ApiRoot + "RenewJWT/";

    const response = await fetch(restUrl, {
      method: "GET",
      headers: {
        "Accept": "application/text;",
        "Authorization": "Bearer " + accessToken
      }
    });

    console.log("In GetRenewedJWT, Response = " + response.status);

    if (response.ok) {
      const stringResponse = await response.text();
      //console.log("In GetRenewedJWT, stringResponse = " + stringResponse);
      sessionStorage.setItem("accessToken", stringResponse);
      return stringResponse;
    } else {
      return null;
    }
  }

  static LoginUser = async (accessToken:string): Promise<number> => {
    var restUrl = this.ApiRoot + "UserLogin/";

    let search = window.location.search;
    let params = new URLSearchParams(search);
    
    var viewModel = new ViewModel();
    var postData: string = JSON.stringify(viewModel);

    const response = await fetch(restUrl, {
      method: "POST",
      body: postData,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + accessToken
      }
    });

    if (response.ok) {
      sessionStorage.setItem("isAuthenticated", "true");
      sessionStorage.setItem("accessToken", accessToken);

      const decodedToken: any = decodeToken(accessToken);
      if (decodedToken && decodedToken.exp) {
        const LoginId = decodedToken['sub'];
        const givenName = decodedToken['given_name'];
        const familyName = decodedToken['family_name'];
        const UserName = givenName + " " + familyName;

        sessionStorage.setItem("LoginId", LoginId);
        sessionStorage.setItem("UserName", UserName)
      }

      var defaultreport = localStorage.getItem("defaultreport"); 
      if (defaultreport) {
        const reportId = defaultreport.replace("/reports/", "");
        const result = await this.ValidateReport(reportId);
        if(result == true) {
          window.location.href = defaultreport
        } else {
          window.location.href = "/"
          localStorage.removeItem("defaultreport");
        }
      } else {
        window.location.href = "/"
      }
    } else {
      sessionStorage.setItem("isAuthenticated", "true");
      sessionStorage.removeItem("accessToken");
      window.location.href = "/"
    }
   
    return response.status;
  }

  static GetUser(): User {
    const user = new User();
    const LoginId = sessionStorage.getItem("LoginId");
    const UserName = sessionStorage.getItem("UserName");

    if (LoginId && UserName) {
      user.LoginId = LoginId;
      user.UserName = UserName;
    }

    return user;
  }

  static GetEmbeddingData = async (): Promise<ViewModel> => {
    const accessToken = this.GetAccessToken();
    if (accessToken === "") return null;

    var restUrl = this.ApiRoot + "Embed/";

    return fetch(restUrl, {
       method: "GET",
       headers: {
         "Accept": "application/json;",
         "Authorization": "Bearer " + accessToken
      }
    }).then(response => response.json())
      .then(response => response);
  }

  static GetEmbedToken = async (): Promise<EmbedTokenResult> => {
    const accessToken = this.GetAccessToken();
    if (accessToken === "") return null;
    //console.log("In GetEmbedToken, accessToken = " + accessToken);

    var restUrl = AppOwnsDataWebApi.ApiRoot + "EmbedToken/";

    return fetch(restUrl, {
      method: "GET",
      headers: {
        "Accept": "application/json;",
        "Authorization": "Bearer " + accessToken
      }
    }).then(response => response.json())
      .then(response => response);
  }

  static RefreshDataset = async (reportId: string): Promise<void> => {
    const accessToken = this.GetAccessToken();
    if (accessToken === "") return;

    var report = new PowerBiReport();
    report.id = reportId;
    var postData: string = JSON.stringify(report);
    var restUrl = this.ApiRoot + "RefreshDataset/";

    const response = await fetch(restUrl, {
      method: "POST",
      body: postData,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + accessToken
      }
    });

    if (!response.ok) {
      alert("Dataset refresh could not be completed.")
    } else {
      await response.text();
    }

    window.location.reload();
    return;

  }

  static LogActivity = async (activityLogEntry: ActivityLogEntry): Promise<void> => {
    document.dispatchEvent(new Event("mousedown"));

    const accessToken = this.GetAccessToken();
    if (accessToken === "") return;

    var postData: string = JSON.stringify(activityLogEntry);
    var restUrl = this.ApiRoot + "ActivityLog/";

    let response = await fetch(restUrl, {
      method: "POST",
      body: postData,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + accessToken
      }
    });

    if (response.ok) {
      await response.text();
    }

    return;

  }

  static ExportFile = async (ExportRequest: ExportFileRequest): Promise<void> => {
    const accessToken = this.GetAccessToken();
    if (accessToken === "") return;

    console.log("Browser language = " + ExportRequest.Locale);
    var restUrl: string = this.ApiRoot + "ExportFile/";
    // prepare JSON body for POST request to retrieve exported report file
    var postData: string = JSON.stringify(ExportRequest);

    // execute POST request synchronously to retrieve exported report file
    let fetchResponse = await fetch(restUrl, {
      method: "POST",
      body: postData,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + accessToken
      }
    });

    // Once POST call returns, get file name from HTTP response
    const header = fetchResponse.headers.get('Content-Disposition');
    const parts = header!.split(';');
    let filename = parts[1].split('=')[1];

    // get blob with export file content
    let blob = await fetchResponse.blob();

    // trigger export file download in browser window
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();

    // return control to caller using await
    return;
  }

  static ValidateReport = async (reportId: string): Promise<boolean> => {
    const accessToken = this.GetAccessToken();
    if (accessToken === "") return;

    var report = new PowerBiReport();
    report.id = reportId;
    var postData: string = JSON.stringify(report);
    var restUrl = this.ApiRoot + "ValidateReport/";

    const response = await fetch(restUrl, {
      method: "POST",
      body: postData,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + accessToken
      }
    });

    if (!response.ok) {
      return false
    }

    return true;
  }

}

